import { API_URL_AWARD_VIDEO } from "@constants/env";
import apiInstance from "@services/Shared/instanceAxios";
import TCreateEditAwardVideo from "types/Award/createEditAwardVideo";

const updateAwardVideo = (_uuid: string, editedItem: TCreateEditAwardVideo) =>
  apiInstance({
    url: API_URL_AWARD_VIDEO,
    method: "put",
    data: editedItem,
  });

export default updateAwardVideo;
